import styled from 'styled-components';

import { DARK_GRAY } from '../../../theme/colors';
import { column, grid, row } from '../../../theme/grid';
import { MAX_WIDTH, SIZE, ZINDEX_CONTENT, mediaQuery, pixelate, unit } from '../../../theme/metrics';

export const Container = styled.div`
	position: relative;
	z-index: ${ZINDEX_CONTENT + 1};
	/* push the content back up */
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	margin-top: -${unit(2)};
	margin-bottom: ${unit(9)};
	background-color: ${DARK_GRAY};

	${mediaQuery[SIZE.medium]} {
		margin-top: -${unit(2)};
		margin-bottom: ${unit(15)};
	}

	${mediaQuery[SIZE.large]} {
		margin-top: -${unit(2)};
		margin-bottom: ${unit(15)};
	}
`;

export const Wrapper = styled.div`
	${grid({ medium: true })}
	position: relative;
	z-index: ${ZINDEX_CONTENT + 1};
	max-width: ${pixelate(MAX_WIDTH)};
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	transform: translateY(${unit(9)});

	${mediaQuery[SIZE.medium]} {
		transform: translateY(${unit(15)});
	}
`;

export const ContentWrapper = styled.div`
	${row({ medium: true })}
`;

export const ImageWrapper = styled.div`
	${column({ medium: { span: 12 } })};
`;

export const Image = styled.img`
	width: 100%;
	height: ${unit(41)};

	${mediaQuery[SIZE.medium]} {
		width: 100%;
		height: ${unit(70)};
	}

	${mediaQuery[SIZE.large]} {
		width: 100%;
		height: ${unit(90)};
	}
`;